import { render, staticRenderFns } from "./proTabel.vue?vue&type=template&id=7b890c58&scoped=true"
import script from "./proTabel.vue?vue&type=script&lang=js"
export * from "./proTabel.vue?vue&type=script&lang=js"
import style1 from "./proTabel.vue?vue&type=style&index=1&id=7b890c58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b890c58",
  null
  
)

export default component.exports